import { NgModule, ApplicationRef, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';

/*
* Platform and Environment providers/directives/pipes
*/
import { routing } from './app.routing';

// App is our top level component
import { App } from './app.component';
import { AppState, InternalStateType } from './app.service';
import { GlobalState } from './global.state';
import { NgaModule } from './theme/nga.module';
import { PagesModule } from './pages/pages.module';
import { AuthModule } from 'app/services/auth/auth.module';
import { NgxElectronModule } from 'ngx-electron';

// Serviços Globais
import { EventsService } from 'app/services/events/events.service';
import { AuthGuard } from 'app/services/auth/auth.guard';
import { AjaxService } from 'app/services/ajax';
import { DecimalPipe } from '@angular/common';


// Application wide providers
const APP_PROVIDERS = [
  AppState,
  GlobalState,
  { provide: LOCALE_ID, useValue: 'pt-BR' },
  EventsService,
  AuthGuard,
  AjaxService,
  DecimalPipe,
];

export type StoreType = {
  state: InternalStateType,
  restoreInputValues: () => void,
  disposeOldHosts: () => void,
};

/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
  bootstrap: [App],
  declarations: [
    App
  ],
  imports: [ // import Angular's modules
    BrowserModule,
    HttpModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgaModule.forRoot(),
    NgbModule.forRoot(),
    PagesModule,
    routing,
    AuthModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    NgxElectronModule,
  ],
  providers: [ // expose our Services and Providers into Angular's dependency injection
    APP_PROVIDERS,
  ]
})

export class AppModule {

  constructor(public appState: AppState) {
  }
}



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/app.module.ts